<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <h2 class="card-title-desc">Processed Payments</h2>
          <TableLoading v-if="orders.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="orders.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
              <template v-slot:actions="slotProps" v-if="checkForPermission(mark_order_as_deposited_permission)">
                <b-button v-if="slotProps.row.depositDetails === null" variant="primary" size="sm" class="py-1 text-white" @click="markAsDeposited(slotProps.row.publicId)">
                  Mark as deposited
                </b-button>
                <!--              <payment-status-component v-else :payment_status="slotProps.row.paymentStatus.name"/>-->
              </template>
              <div class="row mb-2">
                <div class="col-3">
                  <div class="input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Deposited</label>
                    <select class="form-select" @change="depositedStatusFilter($event)">
                      <option value="all" selected>All</option>
                      <option :value="1">True</option>
                      <option :value="2">False</option>
                    </select>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Payment Methods</label>
                    <select class="form-select" @change="paymentStatusFilter($event)">
                      <option value="all" selected>All</option>
                      <option value="9f9d8765-610f-4112-aa7a-5e92e22cbecb">Mpesa</option>
                      <option value="e3d9310c-ed9b-450b-8b02-fb32daa03e14">Cheque</option>
                      <option value="0f4f6de8-bc58-4a41-9597-72447dbe1de9">Cash</option>
                      <option value="b03943ee-ee06-4518-b69c-3c091b68a226">Bank Transfer</option>
                      <option value="6642a601-83ab-4e45-bb20-5f20c1ffc29f">Airtel Money</option>
                    </select>
                  </div>
                </div>
              </div>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="orders.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import DataTable from "@/components/data-table";
import {ALL_CUSTOMER_ORDERS_FINANCE} from "@/gql/orders";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Processed Payments",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    TableLoading,
    DataTable,PageHeader, Layout},
  name: "processed-payments",
  data() {
    return {
      title: "Processed Payments",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Processed Payments",
          active: true
        }
      ],
      mark_order_as_deposited_permission: permissions.mark_order_as_deposited_permission,
      filterValue: '',
      orders: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      paymentStatus: [10],
      isDeposited: 0,
      paymentMethods: [],
      columns: [
        {
          field: 'customer.customerCode',
          label: 'Customer Code'
        },
        {
          field: 'customer.name',
          label: 'Customer Name'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'paymentReceivedDate',
          label: 'Payment Date',
        },
        {
          field: 'paymentDetails.paymentRef',
          label: 'Transaction Reference',
        },
        {
          field: 'orderStatus',
          label: 'Order Status'
        },
        {
          field: 'paymentStatus',
          label: 'Payment Status'
        },
        {
          field: 'grossOrderTotal',
          label: 'Total'
        },
        {
          field: 'paymentDetails',
          label: 'Mode of payment',
        },
        {
          field: 'actions',
          label: 'Action'
        },
      ]
    }
  },
  apollo: {
    orders: {
      query: ALL_CUSTOMER_ORDERS_FINANCE,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
          orderPayment: this.paymentStatus,
          paymentMethods: this.paymentMethods,
          isDeposited: this.isDeposited
        }
      }
    }
  },
  computed: {
    statusFilter(){
      let records = this.rows
      if (this.filterValue){
        records =  this.rows.filter(record => record.payment_status.toLowerCase() === this.filterValue)
      }
      return records
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      changePaymentDeposit: 'orders/changeOrderPaymentDeposit'
    }),
    async markAsDeposited(data){
      await this.changePaymentDeposit({'orderId': data}).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.orders.refetch()
        }
      })
    },
    searchFn(data){
      this.searchKeyword = data
    },
    changeStatusFilter(event){
      this.filterValue = event.target.value
    },
    depositedStatusFilter(event){
      const value = event.target.value
      if(event.target.value === 'all'){
        this.isDeposited = 0
      }else {
        this.isDeposited = parseInt(value)
      }
    },
    paymentStatusFilter(event){
      const value = event.target.value
      if(event.target.value === 'all'){
        this.paymentMethods = []
      }else {
        this.paymentMethods = [value]
      }
    }
  }
}
</script>

<style scoped>

</style>
